import React, {
  memo,
  useState,
  forwardRef,
  useCallback,
  useEffect,
  useRef,
  useImperativeHandle,
} from "react";
import { WithErrorHandler } from "newcar-ui/output/cjs/components/WithErrorHandler";
import { Prompt } from "newcar-ui/output/cjs/components/Prompt";
import { CityPop } from "newcar-ui/output/cjs/components/CityPop";
import { SelectBLP } from "newcar-ui/output/cjs/components/SelectBLP";
import { tools } from "newcar-ui/output/cjs/utils";
import { appMethods } from "newcar-ui/output/cjs/appMethods";
import { TelInput, AgreePrivacy, SelectComponent } from "./input";
import {
  sendAskPrice,
  getIsNeedMsgCode,
} from "newcar-ui/output/cjs/utils/newcarCommonApis";
import { useStateRef } from "newcar-ui/output/cjs/utils/autoHooks";
import "./index.scss";

const Index = forwardRef((props, ref) => {
  const {
    f = "",
    lineId: pageLineId = "",
    lineName: pageLineName = "",
  } = props;
  const [cityPopShow, setCityPopShow] = useState(false);
  const [cityInfo, setCityInfo] = useState({ cityname: "北京", cityid: 613 });
  const [blPopShow, setBLPopShow] = useState(false);
  const [username, setUsername] = useState("");
  const [tel, setTel] = useState("");
  const [isChecked, setIsChecked] = useState(true);
  const [errorTips, setErrorTips] = useState("");
  const [showPrompt, setShowPrompt] = useState(false);
  const [loading, setLoading, loadingRef] = useStateRef(false);
  const [platform, setPlatform] = useState("");
  const [lineInfo, setLineInfo] = useState({
    lineId: pageLineId,
    lineName: pageLineName,
  });
  useImperativeHandle(
    ref,
    () => {
      return {
        getTop: (callback) => {
          // 获取当前组件位置
          callback(askWrapRef.current.offsetTop);
        },
        setNameInputFocus: () => {
          if (inputNameRef.current) {
            inputNameRef.current.setInputFocus();
          }
        },
        getAskLowPriceHeight: () => {
          if (askWrapRef.current) {
            return askWrapRef.current.offsetHeight;
          }
          return 0;
        },
        setNameInputOnblur: () => {
          if (inputNameRef.current) {
            inputNameRef.current.setInputBlurs();
          }
        },
        setTelInputFocus: () => {
          if (inputTelRef.current) {
            inputTelRef.current.setInputFocus();
          }
        },
        setTelInputOnBlur: () => {
          if (inputTelRef.current) {
            inputTelRef.current.setInputBlurs();
          }
        },
      };
    },
    []
  );

  const inputNameRef = useRef();
  const askWrapRef = useRef(null);
  const inputTelRef = useRef();

  useEffect(() => {
    if (window.getCity) {
      window.getCity((c) => {
        setCityInfo({
          cityid: c.cityid,
          cityname: c.name,
        });
      });
    }
    if (tools.is58App()) {
      setPlatform("app");
      appMethods.getUserInfo().then((res) => {
        const userInfoData = res;
        appMethods.getImei().then((imeiInfo) => {
          const imeiData = imeiInfo;
          // 获取是否需要验证码
          getIsChecked("app", {
            ...imeiData,
            prodoctorid: userInfoData.prodoctorid,
            accessmode: userInfoData.accessmode,
          });
        });
      });
    } else if (
      typeof window != "undefined" &&
      navigator.userAgent.match(/AppleWebKit.*Mobile.*/)
    ) {
      setPlatform("m");
      getIsChecked("m");
    } else {
      setPlatform("pc");
      getIsChecked("pc");
    }
  }, []);

  // useEffect(() => {
  //   if (username.length > 0 || tel.length > 0) {
  //     setShowSubmit(true);
  //   } else {
  //     setShowSubmit(false);
  //   }
  // }, [username, tel]);

  const getIsChecked = useCallback(
    async (platform, appParams) => {
      // 获取是否需要验证码
      try {
        const params = {
          f: f,
          platform: platform,
          uuid: tools.getCookie("58tj_uuid"),
          ...appParams,
        };

        const res = await getIsNeedMsgCode({
          ...params,
        });

        if (res.code === 0 && res.entity && res.entity.data) {
          const { select } = res.entity.data;
          setIsChecked(select);
        } else {
          throw res;
        }
      } catch (err) {
        console.log("获取是否默认选中失败--->", err);
      }
    },
    [props]
  );

  const onShowCityFn = useCallback(() => {
    // 显示城市弹窗
    setCityPopShow(true);
  }, []);

  const onChangeInput = useCallback((val, type) => {
    // 监听input change
    if (type === "name") {
      setUsername(val);
    } else if (type === "tel") {
      setTel(val);
    }
  }, []);

  const onChangePrivacy = useCallback((isCheck) => {
    // 监听协议选中状态
    setIsChecked(isCheck);
  }, []);

  const onGetLowprice = useCallback(
    async (e) => {
      // 提交表单
      e.preventDefault();
      e.stopPropagation();

      if (loadingRef.current) {
        return;
      }
      if (!lineInfo.lineId) {
        onShowError("请选择您喜欢的车型");
        return;
      }
      // if (!username) {
      //   onShowError("请输入您的姓名");
      //   return;
      // } else if (!tools.onlyChinese(username) || username.length > 5) {
      //   onShowError("请输入正确的姓名");
      //   return;
      // }

      if (!tel) {
        onShowError("请输入您的手机号码");
        return;
      } else if (!tools.isMobile(tel)) {
        onShowError("请输入正确的电话号码");
        return;
      }
      if (!isChecked) {
        onShowError("请勾选隐私协议");
        return;
      }
      // tools.sendClickStatistics_wmda("27", {
      //   page: "prd-index",
      //   actiontype: "click",
      //   product_id: props.productId,
      //   page_type: "prd",
      // });
      setLoading(true);
      try {
        const params = {
          name: username || `${cityInfo.cityname}车友`,
          f: f,
          fromCode: tools.getUrlParam("from") || tools.getCookie("from_code"),
          cityId: cityInfo.cityid,
          phone: tel,
          checkType: 0,
          platform: platform,
          uuid: tools.getCookie("58tj_uuid"),
          lineId: lineInfo.lineId,
        };
        const res = await sendAskPrice({ ...params });
        if (res.code === 0 && res.entity && res.entity.data) {
          // 询价成功
          onShowError("咨询成功，稍后会有工作人员与您联系。")
          setLoading(false);
        } else {
          throw res;
        }
      } catch (err) {
        setLoading(false);
        console.log("err-->", err);
      }
    },
    [
      username,
      tel,
      platform,
      props,
      lineInfo,
      cityInfo,
      isChecked,
    ]
  );

  const onShowError = useCallback((text) => {
    // 显示错误信息
    setErrorTips(text);
    setShowPrompt(true);
  }, []);

  const hidePrompt = useCallback(() => {
    // 隐藏错误提示
    setShowPrompt(false);
  }, []);
  const setSeletedInfo = useCallback((info) => {
    setCityInfo({ cityid: info.cid, cityname: info.name });
    setCityPopShow(false);
  }, []);
  const changeLineFun = useCallback((info) => {
    const { lineId, lineName } = info;
    setLineInfo({ lineId, lineName });
    setBLPopShow(false);
  }, []);
  const showBLPFun = useCallback(() => {
    setBLPopShow(true);
  }, []);

  return (
    <div className="wrap_style talk-lowprice-wrap" ref={askWrapRef}>
      <div className="top-area">
        <div className="top-area-title">买车咨询，获取最低报价</div>
        <div onClick={onShowCityFn} className="city-info">
          <div className="address-icon">
            <img src="//icon.xgo-img.com.cn/article/22051917/newbrand-address.png" />
          </div>
          <span>{cityInfo.cityname}</span>
        </div>
      </div>
      <form className="form-wrap">
        <SelectComponent
          val={lineInfo.lineName || ""}
          onClick={showBLPFun}
        ></SelectComponent>
        {/* <NameInput
          onChange={(val) => onChangeInput(val, "name")}
          ref={inputNameRef}
        /> */}
        <TelInput
          onChange={(val) => onChangeInput(val, "tel")}
          ref={inputTelRef}
        />

        <AgreePrivacy
          checked={isChecked}
          getCheckStatus={onChangePrivacy}
        />

        <div
          className="get-price-btn"
          onClick={onGetLowprice}
        >
          {loading ? "询价中..." : "获取底价"}
        </div>
      </form>
      <Prompt show={showPrompt} tipStr={errorTips} closeFun={hidePrompt} />
      <CityPop
        show={cityPopShow}
        selected={cityInfo.cityid}
        closeFun={() => {
          setCityPopShow(false);
        }}
        callbackFun={setSeletedInfo}
      ></CityPop>
      <SelectBLP
        show={blPopShow}
        level="BL"
        closeFun={() => {
          setBLPopShow(false);
        }}
        callbackFun={changeLineFun}
      ></SelectBLP>
    </div>
  );
});
Index.defaultProps = {
  f: "",
  lineId: "",
  lineName: "",
};

export default WithErrorHandler(memo(Index));
